import React, { useState } from "react";
import { FaStar } from "react-icons/fa";
import ReviewFormRHF from "./ReviewFormRHF";
import Message from "./LoadingError/Error";

const ProductPreview = ({ product }) => {

    const [selectedRating, setSelectedRating] = useState(null);

    const reviews = [
        {
            id: 1,
            name: "Hairy",
            rating: 5,
            date: "07/08/2024",
            comment: "Best material and good quality.",
        },
    ];

    const totalReviews = reviews.length;
    const averageRating =
        reviews.reduce((acc, r) => acc + r.rating, 0) / totalReviews;

    return (
        <div className="w-full md:p-4">


            <div className="flex gap-6  flex-col lg:flex-row">
                {/* Left: Summary */}
                <div className="w-full lg:w-1/3 ">
                    <h2 className="text-xl font-bold mb-4">Đánh giá</h2>
                    <div className="bg-[--color-button-1] rounded p-8 grid grid-cols-3 items-center">
                        <div className="col-span-1 flex flex-col items-center">

                            <div className=""><span className="text-5xl font-bold">{averageRating.toFixed(1)}</span> <span className="text-2xl font-bold"> /5</span></div>

                            <div className="text-gray-500 text-sm">{totalReviews} Đánh giá</div>
                        </div>
                        <div className="col-span-2 flex flex-col gap-4">
                            {[5, 4, 3, 2, 1]?.map((star) => {
                                const count = reviews.filter((r) => r.rating === star).length;
                                return (
                                    <div key={star} className="flex items-center gap-2 text-sm">
                                        <span className="flex items-center">{star} <FaStar className="text-yellow-500" /></span>
                                        <div className="flex-1 h-2 bg-gray-200 rounded">
                                            <div
                                                className="h-2 bg-yellow-500 rounded"
                                                style={{
                                                    width: `${(count / totalReviews) * 100
                                                        }%`,
                                                }}
                                            ></div>
                                        </div>
                                        <span>{count}</span>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    {/* Add Review */}
                   
                </div>

                {/* Right: Reviews List */}
                <div className="flex-1 w-full lg:w-2/3" >
                    {/* Sort & Limit */}
                    <div className="flex justify-start   gap-2 mb-3">
                        <select className="border rounded px-2 py-1 text-sm">
                            <option>Hiện tại</option>
                            <option>Đánh giá cao nhất</option>
                            <option>Đánh giá thấp nhất</option>
                        </select>
                        <select className="border rounded px-2 py-1 text-sm">
                            <option>10</option>
                            <option>20</option>
                            <option>50</option>
                        </select>
                    </div>

                    {/* Review Item */}
                    {product?.reviews?.map((r) => (
                        <div
                            key={r.id}
                            className="border rounded p-3 mb-3 flex flex-col gap-2"
                        >
                            <div className="flex items-center justify-between gap-2">
                                <div className="flex items-center gap-2">
                                    <div className="flex text-yellow-500">
                                        {[...Array(r.rating)]?.map((_, i) => (
                                            <FaStar key={i} size={14} />
                                        ))}
                                    </div>
                                </div>
                                <span className="text-xs text-gray-500">{r.date}</span>
                            </div>
                            <div className="flex items-center gap-2 mt-1">
                                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-200 font-semibold">
                                    {r.name[0]}
                                </div>
                                <span className="font-semibold">{r.name}</span>
                            </div>
                            <p className="text-gray-700 mt-1 text-sm">{r.comment}</p>
                        </div>
                    ))}
                    {!product?.reviews || product?.reviews.length <= 0 && <Message variant={"info"}>Chưa có đánh giá nào, hãy dẫn đường và chia sẻ suy nghĩ của bạn</Message>}
                    <ReviewFormRHF productId={product._id}/>
                </div>
            </div>


        </div>
    );
};

export default ProductPreview;
